/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React, { useEffect, useState } from "react"
import { Button, Grid, TextGroupSmall } from "@cd2/components"
import { P } from "@cd2/text/build/es6"
import { IRecord } from "../types/schema"
import { useAsyncEffect } from "../hooks/useAsyncEffect"

export function RefreshTokenBanner() {
  const skeem = window.skeem
  const [show, setShow] = useState(false)
  const [currentToken, setCurrentToken] = useState<string | null>(null)

  const myColors = {
    bg: "#b7ffa5",
    border: "#64ff50",
  }

  useAsyncEffect(async () => {
    const record = await skeem.fetch2<IRecord<"refreshTokens", "token"> | null>({
      first: { name: "refreshTokens", attributes: ["token"] },
    })

    const token = record?.token ?? ""
    setCurrentToken(token)
  }, [])

  useEffect(() => {
    if (!currentToken) {
      return
    }
    const clear = setAsyncInterval(async () => {
      const record = await skeem.fetch2<IRecord<"refreshTokens", "token"> | null>({
        first: { name: "refreshTokens", attributes: ["token"] },
      })

      const latestToken = record?.token ?? ""

      if (currentToken !== latestToken) {
        setShow(true)
      }
    }, 10000)

    return () => clear()
  }, [currentToken])

  if (!show) {
    return null
  } else {
    return (
      <div
        css={css`
          border: 1px solid ${myColors.border};
          padding: 16px;
          background-color: ${myColors.bg};
          text-decoration: none;
          transition: 0.2s ease-in-out;
        `}
        className="window-width-sticky"
      >
        <Grid columns={[{ fr: 1 }, "max-content"]}>
          <div
            css={css`
              max-width: 800px;
              display: inline-block;
            `}
          >
            <TextGroupSmall
              theme={{ body: { color: "#666" } }}
              heading="There is an update available."
              body={
                <React.Fragment>
                  <P>
                    There is a new version of the system is available, please save any changes and
                    refresh the page.
                  </P>
                </React.Fragment>
              }
            />
          </div>
          <div>
            <Button onClick={() => window.location.reload()}>Reload Now</Button>
          </div>
        </Grid>
      </div>
    )
  }
}
function setAsyncInterval(callback: () => Promise<void>, ms: number) {
  let timeout: any

  function tick() {
    callback()
      .then(() => {
        timeout = setTimeout(tick, ms)
      })
      .catch(err => {
        console.error("error in async interval", err)
        timeout = setTimeout(tick, ms)
      })
  }

  timeout = setTimeout(tick, ms)

  return () => clearTimeout(timeout)
}
